<app-loading class="full-screen" *ngIf="!qr_details && !error_occurred; else dataToShow"></app-loading>
<ng-template #dataToShow>
  <ng-container *ngIf="error_occurred; else dataReceived">
    <ng-container [ngSwitch]="error_occurred">
      <app-public-information-page *ngSwitchCase="error_code_keys.INACTIVE_PROFILE.key"
        [message_mode]="error_code_keys.INACTIVE_PROFILE.message_type"></app-public-information-page>
      <app-public-information-page *ngSwitchCase="error_code_keys.PROFILE_NOT_FOUND.key"
        [message_mode]="error_code_keys.PROFILE_NOT_FOUND.message_type"></app-public-information-page>
      <app-public-information-page *ngSwitchCase="error_code_keys.MAXIMUM_SCANS_REACHED.key"
        [message_mode]="error_code_keys.MAXIMUM_SCANS_REACHED.message_type"></app-public-information-page>
      <app-qr-not-found [home]="fallback" *ngSwitchDefault></app-qr-not-found>
    </ng-container>
  </ng-container>
  <ng-template #dataReceived>
    <ng-container *ngIf="qr_record_types.QROFFTHESHELF === qr_details.record_type; else notOffTheShelfQrCode">
      <div class="off-the-shelf-wrapper">
        <div class="off-the-shelf-contents">
          <div class="off-the-shelf-container bg-white my-3 p-3">
            <div class="row">
              <div class="col-md-5 order-lg-1 order-2">
                <ng-container [ngSwitch]="qr_details.code_category">
                  <ng-container *ngSwitchCase="all_categories.SOCIAL_MEDIA">
                    <img loading="lazy" src="assets/qr-generator/social-media.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.COUPONS">
                    <img loading="lazy" src="assets/qr-generator/coupons.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.VCARD_PRO">
                    <img loading="lazy" src="assets/qr-generator/vcard-pro-style-16.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.PET">
                    <img loading="lazy" src="assets/qr-generator/pet-style-9.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.BUSINESS_PAGE">
                    <img loading="lazy" src="assets/qr-generator/business-page.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.FEEDBACK">
                    <img loading="lazy" src="assets/qr-generator/feedback.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.RATING">
                    <img loading="lazy" src="assets/qr-generator/rating.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.VIDEOS">
                    <img loading="lazy" src="assets/qr-generator/videos.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.EVENT">
                    <img loading="lazy" src="assets/qr-generator/event.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.VACANCY">
                    <img loading="lazy" src="assets/qr-generator/vacancy.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.PDF">
                    <img loading="lazy" src="assets/qr-generator/pdf.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.APP">
                    <img loading="lazy" src="assets/qr-generator/app.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.MEMORIES">
                    <img loading="lazy" src="assets/qr-generator/memories.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.MP3">
                    <img loading="lazy" src="assets/qr-generator/mp3.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.IMAGES">
                    <img loading="lazy" src="assets/qr-generator/images.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.WEBSITE">
                    <img loading="lazy" src="assets/qr-generator/website.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.LOCATION_PLUS">
                    <img loading="lazy" src="assets/qr-generator/location-plus.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.LONG_PLAIN_TEXT">
                    <img loading="lazy" src="assets/qr-generator/plain-long-text.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchCase="all_categories.RESTAURANT_MENU">
                    <img loading="lazy" src="assets/qr-generator/restaurant-menu.png" height="500">
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <img loading="lazy" src="assets/qr-generator/default.png" height="500">
                  </ng-container>
                </ng-container>
              </div>
              <div class="col-md-7 order-lg-2 order-1">
                <div class="off-the-shelf-child text-center">
                  <img loading="lazy" src="assets/success.png" class="my-3" width="50%">
                  <h4 *ngIf="getOTSFormattedCategory(qr_details.code_category); let result">
                    <i class="{{result.icon}} me-2"></i>
                    {{result.text}}
                  </h4>
                  <p>
                    If you are the owner of this QR code, kindly "Sign Up" and save the profile data
                    to
                    activate your corresponding digital profile.
                  </p>
                  <ng-container *ngIf="qr_details.has_activation_code">
                    <form #loginForm="ngForm" [formGroup]="activation_form" (ngSubmit)="activateOTS()">
                      <div class="mb-1">
                        <label class="form-label bold">Activation code<i
                            class="bi bi-info-circle-fill text-success small ms-2"
                            title="We sent your activation code to the email address you used during checkout. Please check your inbox (and spam folder) and if you still can't find it, please contact us."
                            data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top"></i></label>
                        <input type="text" maxlength="60" formControlName="activation_code_ots_qr"
                          [class.is-invalid]="(activation_form.get('activation_code_ots_qr').hasError('required') && activation_form.get('activation_code_ots_qr').touched)"
                          required class="form-control text-center">
                        <ng-container *ngIf="activation_form.get('activation_code_ots_qr').touched">
                          <p class="input-error"
                            *ngIf="activation_form.get('activation_code_ots_qr').hasError('required')">
                            Activation code is required!</p>
                        </ng-container>
                        <p class="input-error" *ngIf="activation_form.get('error').value">
                          {{activation_form.get('error').value}}</p>
                      </div>
                      <button type="submit" class="btn btn-primary btn-block my-2"
                        [disabled]="activation_form.controls.activating.value">
                        <app-inline-loader
                          *ngIf="activation_form.controls.activating.value; else notProcessing"></app-inline-loader>
                        <ng-template #notProcessing>
                          <span>Activate</span>
                        </ng-template>
                      </button>

                      <div class="text-end">
                        <a routerLink="/contact-us" target="_blank">Contact us</a>
                      </div>
                    </form>
                  </ng-container>
                  <ng-container *ngIf="!qr_details.has_activation_code">
                    <button class="btn btn-primary mt-1 w-100" [disabled]="!!ots_error"
                      (click)="activateOTS()">Activate</button>
                  </ng-container>
                  <div class="alert alert-danger d-flex align-items-center animated fadeIn mt-3" role="alert"
                    *ngIf="ots_error">
                    <div class="bi bi-exclamation-circle-fill"></div>
                    <div>{{ots_error}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #notOffTheShelfQrCode>
      <div [ngStyle]="{'background': background_image ? 'url(' + background_image + ')' : background_color }">
        <ng-container [ngSwitch]="qr_details.code_category">
          <ng-container *ngSwitchCase="all_categories.SOCIAL_MEDIA">
            <app-qrs-social-media [social_data]="social_data" [qr_url]="qr_details.qr_url"
              [data]="qr_details.socials_data">
            </app-qrs-social-media>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.COUPONS">
            <app-qrs-coupon [social_data]="social_data" [qr_url]="qr_details.qr_url"
              [data]="qr_details.coupons_data"></app-qrs-coupon>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.VCARD_PRO">
            <app-qrs-vcard-pro [social_data]="social_data" [qr_url]="qr_details.qr_url"
              [data]="qr_details.vcardpro_data">
            </app-qrs-vcard-pro>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.PET">
            <app-qrs-pet [social_data]="social_data" [short_id]="qr_details.short_id" [qr_url]="qr_details.qr_url"
              [data]="qr_details.pet_data">
            </app-qrs-pet>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.BUSINESS_PAGE">
            <app-qrs-business-page [social_data]="social_data" [qr_url]="qr_details.qr_url"
              [data]="qr_details.businesspage_data">
            </app-qrs-business-page>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.FEEDBACK">
            <app-qrs-feedback [social_data]="social_data" [qr_url]="qr_details.qr_url" [qr_details]="qr_details"
              [short_id]="qr_details.short_id" (_error)="error_occurred = $event"></app-qrs-feedback>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.RATING">
            <app-qrs-rating [social_data]="social_data" [qr_url]="qr_details.qr_url" [qr_details]="qr_details"
              [short_id]="qr_details.short_id" (_error)="error_occurred = $event"></app-qrs-rating>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.RESTAURANT_MENU">
            <app-qrs-restaurant-menu [social_data]="social_data" [qr_url]="qr_details.qr_url"
              [data]="qr_details.restaurant_menu_data"></app-qrs-restaurant-menu>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.LONG_PLAIN_TEXT">
            <app-qrs-long-plain-text [social_data]="social_data" [qr_url]="qr_details.qr_url"
              [data]="qr_details.long_plain_text_data"></app-qrs-long-plain-text>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.VIDEOS">
            <app-qrs-video [social_data]="social_data" [qr_url]="qr_details.qr_url"
              [data]="qr_details.videos_data"></app-qrs-video>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.EVENT">
            <app-qrs-event [social_data]="social_data" [qr_url]="qr_details.qr_url"
              [data]="qr_details.event_data"></app-qrs-event>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.VACANCY">
            <app-qrs-vacancy [social_data]="social_data" [qr_url]="qr_details.qr_url" [qr_details]="qr_details"
              [short_id]="qr_details.short_id" (_error)="error_occurred = $event"></app-qrs-vacancy>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.PDF">
            <app-qrs-pdf [social_data]="social_data" [qr_url]="qr_details.qr_url"
              [data]="qr_details.pdf_data"></app-qrs-pdf>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.APP">
            <app-qrs-app [social_data]="social_data" [qr_url]="qr_details.qr_url"
              [data]="qr_details.app_data"></app-qrs-app>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.MP3">
            <app-qrs-mp3 [social_data]="social_data" [qr_url]="qr_details.qr_url"
              [data]="qr_details.mp3_data"></app-qrs-mp3>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.IMAGES">
            <app-qrs-images [social_data]="social_data" [qr_url]="qr_details.qr_url"
              [data]="qr_details.images_data"></app-qrs-images>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.MEMORIES">
            <app-qrs-memories [social_data]="social_data" [qr_url]="qr_details.qr_url" [qr_id]="qr_details.id"
              [short_id]="qr_details.short_id" [data]="qr_details.memories_data"
              [total_responses]="qr_details.total_responses" [team_id]="qr_details.team_id"></app-qrs-memories>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.WEBSITE">
            <app-loading class="full-screen"></app-loading>
          </ng-container>
          <ng-container *ngSwitchCase="all_categories.LOCATION_PLUS">
            <app-loading class="full-screen"></app-loading>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <app-qr-not-found [home]="fallback"></app-qr-not-found>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>

  </ng-template>
</ng-template>
<app-shared-popup [event_popup]="history_obs.asObservable()"></app-shared-popup>